import * as React from "react"
import {isNull as _isNull} from "lodash";
import TextAreaInput from "../../components/TextAreaInput";
import {
    ForceCloseReason,
    OnlineForceCloseReasons,
    IncentreForceCloseReasons,
    AppConstants
} from "../../utils/AppConstants";
import { IForceCloseReasons } from "../../models/IForceCloseReasons";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { EventNames } from "../../utils/EventTrackerConstants";
import AppUtils from "../../utils/AppUtils";

/*
 * created by aditya on 23/07/2018
 */

export interface ForceCloseConsultationProps {
    consultationMode: string;
    forceCompleteAppointment: (status: string, reasonCode: ForceCloseReason, reasonText: string) => void;
    toggleForceCloseModal(): void;
}

export interface ForceCloseConsultationState {
    reasonCode: IForceCloseReasons,
    reasonText: string,
    forceCloseReasons: IForceCloseReasons[]
}

class ForceCloseConsultation extends React.Component<ForceCloseConsultationProps, ForceCloseConsultationState> {
    constructor(props: ForceCloseConsultationProps) {
        super(props);
        this.state = {
            reasonCode: null,
            reasonText: null,
            forceCloseReasons: null
        }
    }

    componentDidMount() {
        const { consultationMode } = this.props;
        // deciding reasons based on consultation mode
        if (consultationMode) {
            if (consultationMode === AppConstants.ConsultationModes.ONLINE.id) {
                this.setState({ forceCloseReasons: OnlineForceCloseReasons });
            }
            else if (consultationMode === AppConstants.ConsultationModes.INCENTRE.id) {
                this.setState({ forceCloseReasons: IncentreForceCloseReasons });
            }
        }
    }

    preventModalClose = (event: any) => {
        event.stopPropagation();
    }
    updateReasonCode = (reason: IForceCloseReasons) => {
        LocalStorageUtils.setClickEvents({ field: reason.reasonTitle, section: EventNames.Exit_Consultation, widget: EventNames.Exit_Consultation })
        this.setState({
            reasonCode: reason
        })
    }
    updateReasonText = (event: any) => {
        this.setState({
            reasonText: event.target.value
        })
    }
    forceComplete = () => {
        LocalStorageUtils.setClickEvents({ field: "End Consultation", section: EventNames.Exit_Consultation, widget: EventNames.Exit_Consultation })
        const { reasonCode: { status, internalValue }, reasonText } = this.state;
        this.props.forceCompleteAppointment(status, ForceCloseReason[internalValue], reasonText);
    }
    render() {
        const { forceCloseReasons } = this.state;
        return (
            <div className="force-close-consultation-container" onClick={this.preventModalClose}>
                <div className="modal-header">Force Close Consultation <span className="close-btn" onClick={this.props.toggleForceCloseModal}>x</span></div>
                <div>
                    <div className="reason-header">Reason</div>
                    <div className="reason-code-main-container">
                        {
                            forceCloseReasons && forceCloseReasons.map((reason: IForceCloseReasons) => {
                                return (<div className="reason-code-container" key={reason.internalValue}>
                                    <input type="radio" name="reason-code" value={reason.internalValue} onClick={() => this.updateReasonCode(reason)} />
                                    <div className="reasons-wrapper">
                                        <span className="input-label">{reason.reasonTitle}</span>
                                        <div className="subtitle">{reason.reasonSubtitle}</div>
                                    </div>
                                </div>)
                            })
                        }
                    </div>
                    <div className="reason-text-container">
                        <TextAreaInput name="force-close-reason" label="Details" onChange={this.updateReasonText} />
                    </div>
                    <div className="save-button collapsible-card">
                        <input disabled={_isNull(this.state.reasonCode)} className="card-primary-action" type="button" value="End Consultation" onClick={this.forceComplete} />
                    </div>
                </div>
            </div>
        )
    }
}

export default ForceCloseConsultation;